import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-off-page-performance-detail',
  templateUrl: './off-page-performance-detail.component.html',
  styleUrls: ['./off-page-performance-detail.component.css']
})
export class OffPagePerformanceDetailComponent implements OnInit {
  campaignId: string = '';
  performance: any = null;
  snapshots: any[] = [];
  loading: boolean = true;
  modalTitle: string = '';
  modalContent: string | null = null;
  modalListItems: any[] | null = null;


  snapshotColumns: string[] = [
    'date',
    'impactScore',
    'position',
    'clicks',
    'summary'
  ];

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.campaignId = this.route.snapshot.paramMap.get('campaignId') || '';
    if (this.campaignId) {
      this.loadDetail();
    }
  }

  loadDetail(): void {
    this.loading = true;
    this.dataService.getData(`offPageAttribution/performance/${this.campaignId}`).subscribe({
      next: (res) => {
         console.log('res attr det', res);
        if (res.rst) {
          this.performance = res.data.performance;
          this.snapshots = res.data.snapshots;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  showModal(title: string, content: string | any[]) {
    console.log('showModal called with:', { title, content });
    this.modalTitle = title;
    if (Array.isArray(content)) {
      this.modalListItems = content;
      this.modalContent = null;
    } else {
      this.modalContent = content;
      this.modalListItems = null;
    }
    console.log('Modal state:', { modalTitle: this.modalTitle, modalContent: this.modalContent, modalListItems: this.modalListItems });
  }


  closeModal() {
    this.modalContent = null;
    this.modalListItems = null;
  }

  getKeywords(element: any): string[] {
    if (!element) return [];

    // Prioritize keywords stored in the performance record itself
    if (element.targetKeywords && Array.isArray(element.targetKeywords) && element.targetKeywords.length > 0) {
      return element.targetKeywords;
    }


    // Fallback to campaign suggestedKeywords
    const campaign = element.campaignId;
    if (!campaign || !campaign.suggestedKeywords) return [];

    if (Array.isArray(campaign.suggestedKeywords)) {
      return campaign.suggestedKeywords;
    } else if (typeof campaign.suggestedKeywords === 'string') {
      return campaign.suggestedKeywords
        .split(',')
        .map((s: string) => s.trim())
        .filter(Boolean);
    } else if (typeof campaign.suggestedKeywords === 'object') {
      const kws: string[] = [];
      if (Array.isArray(campaign.suggestedKeywords.shortTerm))
        kws.push(...campaign.suggestedKeywords.shortTerm);
      if (Array.isArray(campaign.suggestedKeywords.mediumTerm))
        kws.push(...campaign.suggestedKeywords.mediumTerm);
      if (Array.isArray(campaign.suggestedKeywords.longTerm))
        kws.push(...campaign.suggestedKeywords.longTerm);
      return kws.filter(Boolean);
    }
    return [];
  }
}

